import React from 'react';
import { EXEMPLAR_MODES } from '../../constants';
import { AWSImage, Image, ImageSide, Section, Side } from '../../types';
import { getExemplarImageURL } from '../../utils';
import { FilledCrossButton } from '../Button/Button';
import { LaterSection } from '../ExemplarScreen/Later/LaterSection';
import { ExemplarImage } from '../Image';
import { CLICKABLE_IMG } from '../Image/EditImage';
import {
  StyledDefaultScreen,
  StyledExemplarWrapper,
  StyledImageFlexWrapper,
  StyledScreenWrapper,
  StyledSideWrapper,
} from '../Styled';
import { StickedImageWrapper, StyledInsideWrapper } from '../Styled/StyledWrappers';
import { ScrollableModal } from './ScrollableModal';

interface IPreviewExemplarModal {
  stage: string;
  exemplarContent: Side;
  color: string;
  getImageStore: () => AWSImage[];
  onClose: () => void;
}

export const PreviewExemplarModal: React.FC<IPreviewExemplarModal> = (props): JSX.Element => {
  const { stage, color, exemplarContent, getImageStore, onClose } = props;
  const { left, right } = exemplarContent;

  const imageSide = right.find(({ type }) => type === 'image') ? 'right' : 'left';
  const proformaImageSection = exemplarContent[imageSide].find(({ type }) => type === 'image') as Image;
  const imageSrc = proformaImageSection ? getExemplarImageURL(proformaImageSection.uuid, getImageStore()) : '';

  const renderFlexWrappedImage = () => (
    <StyledImageFlexWrapper
      hasPosition={false}
      key={proformaImageSection.id}
      data-testid={`flex-wrapped-${imageSide}-image`}
    >
      <ExemplarImage
        width={100}
        height={100}
        data-testid="visible-prview-image"
        isVisible={true}
        className={CLICKABLE_IMG}
        src={imageSrc}
        alt="preview-image"
        borderRadius="10px"
      />
    </StyledImageFlexWrapper>
  );

  const renderContent = (sections: Array<Section | Image>, side: ImageSide) => {
    const isSectionWithImage = imageSide === side;

    const textSections = (
      <>
        {side === 'right' && (
          <LaterSection
            editMode={false}
            hidden={true}
            section={left[0] as Section}
            mode={EXEMPLAR_MODES.textPresentation}
            isPreviewModal
            stage={stage}
          />
        )}
        {sections.map((section: Section | Image) => {
          if ('lines' in section) {
            return (
              <LaterSection
                editMode={false}
                section={section}
                key={section.id}
                mode={EXEMPLAR_MODES.textPresentation}
                isPreviewModal
                side={side}
                isAccessible={true}
                stage={stage}
              />
            );
          }
        })}
      </>
    );

    if (isSectionWithImage) {
      return (
        <>
          <div>{textSections}</div>
          {imageSrc ? (
            renderFlexWrappedImage()
          ) : (
            <StickedImageWrapper imageSide={side}>{renderFlexWrappedImage()}</StickedImageWrapper>
          )}
        </>
      );
    }

    return textSections;
  };

  return (
    <ScrollableModal onClose={onClose}>
      <>
        <FilledCrossButton bgColor={color} onClick={onClose} />
        <StyledInsideWrapper isFullScreen={false} width="926px">
          <StyledScreenWrapper data-testid="preview-screen-wrapper" stage={stage}>
            <StyledExemplarWrapper padding="0px 32px 0 39px">
              <StyledDefaultScreen isPresentationMode tabIndex={0}>
                <StyledSideWrapper isImageStickedToBottom={imageSide === 'left'}>
                  {renderContent(exemplarContent.left, ImageSide.left)}
                </StyledSideWrapper>
                <StyledSideWrapper isImageStickedToBottom={imageSide === 'right'}>
                  {renderContent(exemplarContent.right, ImageSide.right)}
                </StyledSideWrapper>
              </StyledDefaultScreen>
            </StyledExemplarWrapper>
          </StyledScreenWrapper>
        </StyledInsideWrapper>
      </>
    </ScrollableModal>
  );
};
